import CompaniesList from './CompaniesOverview/CompaniesList';
import CompanyItem from './CompaniesOverview/CompanyItem';

export {
  CompaniesList,
  CompanyItem,
};



// WEBPACK FOOTER //
// ./src/components/Companies/index.js